/**
 * Root route — every page in the cockpit descends from here.
 *
 * Providers that depend on TanStack Router's state (useRouterState,
 * useParams) MUST mount inside the router tree, not above it. Per
 * KEN_LAYER_7 §8.1.1 the TenantProvider derives the active tenant
 * from the URL via useRouterState; that hook only works under
 * <RouterProvider>. The same applies to ApiClientProvider (depends on
 * the auth store but also the tenant URL) and TerminologyProvider
 * (depends on the resolved tenant for term overrides). AuthProvider
 * lives above the router in main.tsx because it owns the session
 * cookie lifecycle and must run before the router decides which
 * route to mount.
 *
 * SS-B7.1: ShellTerminologyProvider fetches GET /api/shell/manifest for the
 * active company and hands its `terminology` to TerminologyProvider; the
 * shared defaults show while it loads and if it fails.
 */

import { Outlet, createRootRoute } from "@tanstack/react-router";

import { ApiClientProvider } from "../providers/ApiClientProvider";
import { ShellTerminologyProvider } from "../providers/ShellTerminologyProvider";
import { TenantProvider } from "../providers/TenantProvider";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent(): ReturnType<typeof Outlet> {
  return (
    <TenantProvider>
      <ApiClientProvider>
        <ShellTerminologyProvider>
          <Outlet />
        </ShellTerminologyProvider>
      </ApiClientProvider>
    </TenantProvider>
  );
}
